import React from 'react';
import { useTranslation } from 'react-i18next';
import { TextButton } from '@oneaudi/unified-web-components';
import { CTAsWrapper, Button } from './CtaGroup.style';

interface ICtaGroupProps {
  vehicleDetailsUrl: string;
  digitalLeadsData: string;
}

const CtaGroup: React.FC<ICtaGroupProps> = ({ vehicleDetailsUrl, digitalLeadsData }) => {
  const { t } = useTranslation();

  return (
    <CTAsWrapper>
      {/* check later ASK */}
      <Button id="digital-leads" data-info={digitalLeadsData}>
        {t('vlp.vehicleResults.vehicleCard.ctas.contactDealer')}
      </Button>
      <TextButton variant="secondary" href={vehicleDetailsUrl}>
        {t('vlp.vehicleResults.vehicleCard.ctas.vdp')}
      </TextButton>
    </CTAsWrapper>
  );
};

export default CtaGroup;
